import { colors, fonts } from '@grupoboticario/flora-tokens/dist/quemDisseBerenice/web/ds'

export const quemDisseBerenice = {
  colors,
  fonts,
}
